import { render, staticRenderFns } from "./OrgHomeIntake.vue?vue&type=template&id=2f3790ea&scoped=true&"
import script from "./OrgHomeIntake.vue?vue&type=script&lang=js&"
export * from "./OrgHomeIntake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3790ea",
  null
  
)

export default component.exports